jQuery(document).ready(function($) {
    'use strict';

    $('.small-grid-swiper').each(function(index) {
        var $swiperObject = $(this);
        var swiperId = 'small-grid-swiper-' + index;
        var nextId = 'small-grid-next-' + index;
        var prevId = 'small-grid-prev-' + index;

        // Add data-id attributes to the elements
        $(this).find('.swiper').attr('data-id', swiperId);
        $(this).find('.swiper-button-next').attr('data-id', nextId);
        $(this).find('.swiper-button-prev').attr('data-id', prevId);

        // Selectors using the data-id attributes
        var swiperSelector = '[data-id="' + swiperId + '"]';
        var nextSelector = '[data-id="' + nextId + '"]';
        var prevSelector = '[data-id="' + prevId + '"]';

        const small_grid_swiper = new Swiper(swiperSelector, {
            slidesPerView: 'auto',
            spaceBetween: 20,
            grabCursor: true,
            speed: 700,
            navigation: {
                nextEl: nextSelector,
                prevEl: prevSelector,
            },
            breakpoints: {
                768: {
                    spaceBetween: 24,
                },
                1280: {
                    spaceBetween: 24,
                },
            }
        });

    });

});
//# sourceMappingURL=swiper-small-grid.js.map
